module.exports = __webpack_public_path__ + "img/agent_yes.82336c8f.svg";